import React, { Component } from 'react';

import { ProgressBar } from '@platform/base';
import { configMap } from '@platform/template';
import './index.less';
import { formatNumber, formatAcuracyRound } from "@platform/api";
class Card extends Component {
    render() {
        let { meta = {}, data = {}, numberItems = [], titleItems = [], progressItems = [] } = this.props;
        return (
            <div className='card-list'>
                {Array.isArray(data.rows) && data.rows.map(row => {
                    return <Item data={row} items={meta.items} numberItems={numberItems} titleItems={titleItems} progressItems={progressItems}></Item>
                })}
            </div>

        )
    }
}
export default Card;

function Item(props) {
    const { items = [], data = {}, numberItems = [], titleItems = [], progressItems = [] } = props;
    let numberSet = new Set(numberItems);
    let titleSet = new Set(titleItems);
    let progressSet = new Set(progressItems);
    let numberFields = [], progressFields = [], otherFields = [], titleFields = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        let { attrcode, visible = true } = item;
        if (visible) {
            //将数字区的字段取出来
            if (numberSet.has(attrcode)) {
                numberFields.push(item);
            } else if (titleSet.has(attrcode)) {
                titleFields.push(item);
            } else if (progressSet.has(attrcode)) {
                progressFields.push(item);
            } else {
                otherFields.push(item);
            }
        }
    }

    return <div className='card-container nc-theme-table-header-bgc'>
        <Title items={titleFields} data={data}></Title>
        <Field items={otherFields} data={data}></Field>
        <NumberArea items={numberFields} progress={progressFields} data={data}> </NumberArea>
    </div>
}

function Title(props) {
    const { items = [], data = {} } = props;
    //只有一个标题
    let titleItem = items[0];
    let { attrcode } = titleItem || {};
    let title = getDisplay(titleItem, data['values'][attrcode]);
    return <h2 className='card-title nc-theme-title-font-c'>{title}</h2>
}

function Field(props) {
    const { items = [], data = {} } = props;
    return <div className='field-container'>
        {items.map(item => {
            let { label, attrcode } = item;
            let display = getDisplay(item, data['values'][attrcode]);
            return <div className='field-item nc-theme-form-input-c'> <span className='field-label'>{label + ' : '}</span> <span className='field-value'>{display}</span></div>
        })}
    </div>
}

function NumberArea(props) {
    const { items = [], data = {}, progress = [] } = props;
    return <div className='number-container nc-theme-card-form-bgc'>
        {items.map(item => {
            let { label, attrcode } = item;
            let display = getDisplay(item, data['values'][attrcode]);
            return <div className='number-item'> <span className='number-label nc-theme-form-input-c'>{label + ' : '}</span> <span className='number-value nc-theme-title-font-c'>{display}</span></div>
        })}
        {progress.map(item => {
            let { attrcode } = item;
            // let display = getDisplay(item, data['values'][attrcode]);
            let display = data['values']?.[attrcode]?.value || 0;
            return <div className='number-progress'><ProgressBar type="circle" percent={display} width={48} /></div>
        })}
    </div>
}

function getDisplay(item, val = {}) {
    let { itemtype, showFractile } = item;
    if(val.scale > -1){
        return formatNumber(formatAcuracyRound(val.value, Number(val.scale), showFractile), false, !showFractile)
    }
    let res = configMap[itemtype]({ ...item, getFieldValue: () => { return val } }).getDisplay();
    return res;
}